export interface SearchableWorkspace {
	id: string
	name: string | null
	domain: string | null
	customDomain: string | null
	emailAddress: string | null
	createdBy: { email: string | null } | null
}

export const normalizeWorkspaceSearch = (raw: string) =>
	raw.trim().toLowerCase()

// Matches what the browser already holds. Member emails live only on the
// server, so those ids arrive separately and widen the result.
export function matchesWorkspaceSearch(
	workspace: SearchableWorkspace,
	term: string,
): boolean {
	if (!term) return true
	if (workspace.id.toLowerCase().startsWith(term)) return true

	return [
		workspace.name,
		workspace.domain,
		workspace.customDomain,
		workspace.emailAddress,
		workspace.createdBy?.email,
	].some((field) => !!field && field.toLowerCase().includes(term))
}

export function filterWorkspacesBySearch<T extends SearchableWorkspace>(
	workspaces: T[],
	rawSearch: string,
	serverMatchIds: ReadonlySet<string> | null,
): T[] {
	const term = normalizeWorkspaceSearch(rawSearch)
	if (!term) return workspaces

	return workspaces.filter(
		(w) => matchesWorkspaceSearch(w, term) || !!serverMatchIds?.has(w.id),
	)
}
